import type { HistoryDateFilterItem } from '@/shared/types';
import { useDictionary } from './useDictionary';

const useHistoryDateFiltersDictionary = () => {
  const { data, isLoading, error } = useDictionary<HistoryDateFilterItem[]>({
    dictionaryName: 'historydatefilters',
  });

  return {
    data,
    isLoading,
    error,
  };
};

export { useHistoryDateFiltersDictionary };
